import React from "react";
import moment from "moment";

export const columns = ({ gymLocations }) => [
  {
    title: "Name",
    render: (a) => a?.user?.name,
    key: "name",
    sorter: (a, b) => (a?.user?.name || "").localeCompare(b?.user?.name || ""),
  },
  {
    title: "Email",
    render: (a) => a?.user?.email,
    sorter: (a, b) => (a?.user?.email || "").localeCompare(b?.user?.email || ""),
  },
  {
    title: "Location",
    align: "center",
    render: (a) => gymLocations[Number(a?.user?.location_id || 1)],
  },
  {
    title: "Start Date",
    align: "center",
    render: (a) => moment(a.subscription_start).format("MMMM Do YYYY"),
  },
  {
    title: "End Date",
    align: "center",
    render: (a) => moment(a.subscription_end).format("MMMM Do YYYY"),
  },
  {
    title: "Status",
    align: "center",
    render: (a) => (
      <span style={{ color: a.status === 1 ? "green" : "red", fontWeight: "bold" }}>
        {a.status === 1 ? "Active" : "Expired"}
      </span>
    ),
  },
];
